import styled, {css} from "styled-components"

interface Props {
  capitalise: boolean
}

export default styled.div<Props>`
  ${({theme, capitalise}) => css`
    margin: ${theme.spacing.one} 0;
    text-transform: ${capitalise ? "capitalize" : "none"};
  
    ${theme.mediaQueries.minWidthMedia.tablet`
      margin: ${theme.spacing.four} 0;
    `}
  `}
`
